// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c0892e16","952":"11efcb27"}[chunkId] + ".chunk.js";
};